/*
 * @Desc: 班级管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-20 16:59:50
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/activity/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/activity/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/activity/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/activity/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/activity/remove",
      method: "post",
      data
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/activity/status",
      method: "post",
      data
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/activity/sort",
      method: "post",
      data
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/activity/select",
      method: "get",
      params: query
    });
  },
  // 活动报名人列表
  person(query) {
    return request({
      url: "/activity/person",
      method: "get",
      params: query
    });
  },
  // 活动评论列表
  comment(query) {
    return request({
      url: "/activity/comment",
      method: "get",
      params: query
    });
  },
  // 隐藏/展示评论
  commentStatus(data) {
    return request({
      url: "/activity/commentStatus",
      method: "post",
      data
    });
  },
  // 删除评论
  commentRemove(data) {
    return request({
      url: "/activity/commentRemove",
      method: "post",
      data
    });
  },
  exportData(data){
    return request({
      url: "/activity/export",
      method: "post",
      data
    });
  }
};
export default index;